import { useLocation } from 'react-router';
import PageEvent from '@/hooks/context/EventCollector/events/PageEvent';
import useEventCollector from '@/hooks/context/EventCollector/useEventCollector';
import useDebounce from '@/hooks/useDebounce';

const usePageTracker = () => {
  const { page } = useEventCollector();
  const location = useLocation();

  useDebounce(() => page(new PageEvent()), 1500, [location.pathname]);
};

export default function PageTracker() {
  usePageTracker();
  return null;
}
